export const API_COLLECTOR_URL = 'https://api.thevalidators.io'
export const API_JPOOL_URL = 'https://api2.jpool.one'
export const API_URL = import.meta.env.VITE_API_URL

export const BUILD_VERSION = import.meta.env.VERSION

export const APP_URL = 'https://jstaking.io'

export const JSTAKING_SERVER_NAME = 'joogh-mainnet-hetzner'

// intervals
export const EPOCH_RELOAD_INTERVAL = 60_000
export const RATES_RELOAD_INTERVAL = 300_000
export const DEFI_RELOAD_INTERVAL = 120_000
export const POOL_RELOAD_INTERVAL = 30_000
export const VALIDATORS_RELOAD_INTERVAL = 600_000

export const JSTAKING_VALIDATOR_VOTE = 'DPmsofVJ1UMRZADgwYAHotJnazMwohHzRHSoomL6Qcao'

export const VALIDATOR_APY = 8.4
